import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { GridIcon, VideoIcon, ImageIcon, MessageCircleIcon, ShieldCheckIcon, WrenchIcon, PrinterIcon } from 'lucide-react';
export function WhatsInsideSection() {
  const features = [{
    icon: <GridIcon className="w-6 h-6 text-sage" data-id="element-183" />,
    title: 'The 10 Icons Rule',
    description: 'The only 10 buttons that actually matter to their daily life.'
  }, {
    icon: <VideoIcon className="w-6 h-6 text-sage" data-id="element-184" />,
    title: 'The Video Call',
    description: 'No more "ceiling fan" shots—they\'ll join calls confidently.'
  }, {
    icon: <ImageIcon className="w-6 h-6 text-sage" data-id="element-185" />,
    title: 'The Photo Rescue',
    description: 'Step-by-step instructions to save every grandchild photo so they never "vanish" again.'
  }, {
    icon: <MessageCircleIcon className="w-6 h-6 text-sage" data-id="element-186" />,
    title: 'The Family Chat',
    description: 'Read and respond to group chats, use emojis, and master the Voice Note.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-sage" data-id="element-187" />,
    title: 'The Scam-Proof Shield',
    description: 'A 3-second red-flag test to spot hackers and fraud cold.'
  }, {
    icon: <WrenchIcon className="w-6 h-6 text-sage" data-id="element-188" />,
    title: 'The 3 Magic Fixes',
    description: 'Solve 90% of phone problems by themselves in under 60 seconds.'
  }, {
    icon: <PrinterIcon className="w-6 h-6 text-sage" data-id="element-189" />,
    title: 'Printable Cheat Sheet',
    description: 'A simple visual key for instant reminders.'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-193">
            What is Inside the 32-Page Guide
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-194">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} className={index === features.length - 1 ? 'md:col-span-2 md:max-w-md md:mx-auto w-full' : ''} data-id="element-195">
              <div className="flex items-start gap-5 p-6 rounded-2xl bg-white border border-warmGray shadow-sm hover:shadow-warm transition-shadow duration-300 h-full" data-id="element-196">
                <div className="bg-sage-light p-3 rounded-xl shrink-0" data-id="element-197">
                  {feature.icon}
                </div>
                <div data-id="element-198">
                  <h3 className="font-bold text-lg mb-2" data-id="element-199">{feature.title}</h3>
                  <p className="text-charcoal/80 leading-relaxed" data-id="element-200">
                    {feature.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}